import {Component, Injector, OnInit} from '@angular/core';
import {IntegrationService} from './integration.service';
import {EntityStatus} from '../../common/models/entity-status.model';
import {EditItemComponent} from '../../common/edit-item.component';
import {IIntegrationModel} from '../../common/models/integration.models';
import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss']
})
export class IntegrationComponent extends EditItemComponent<IIntegrationModel> implements OnInit {
  public static readonly componentName: string = 'IntegrationComponent';
  public readonly EntityStatus = EntityStatus;
  public clubId: string;
  fieldMessages = {
    fromniToken: {
      required: 'Токен не может быть пустым',
      invalidToken: 'Не валидный токен',
      invalidFormat: 'Токен должен быть 32 символа подряд или в формате xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
    }
  };

  constructor(injector: Injector, protected service: IntegrationService) {
    super(injector, service);
  }

  async ngOnInit() {
    super.ngOnInit();
    this.clubId = this.routingParams.clubId;
  }

  public close() { }

  public finishEditIfPublished() {
    this.Model.fromniToken = this.Model.fromniToken.replace(/\r?\n/g, ' ').trim()
    this.Model.fromniToken && this.finishEdit();
  }

  private fromniTokenValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value || value.trim() === '') {
        return { required: 'Токен не может быть пустым' };
      }

      if (value === '00000000000000000000000000000000' || value === '00000000-0000-0000-0000-000000000000') {
        return { invalidToken: '' };
      }

      // Проверка формата GUID: 32 символа, только цифры и буквы a-f, A-F
      const guidPattern = /^([0-9a-fA-F]{32}|[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12})$/;
      if (!guidPattern.test(value)) {
        return { invalidFormat: '' };
      }

      return null;
    };
  }

  buildForm() {
    this.form = this.formBuilder.group({
      id: ['00000000000000000000000000000000', []],
      clubId: [this.Model.clubId, []],
      fromniToken: [this.Model.fromniToken, [this.fromniTokenValidator()]],
    });
  };

  protected modelTemplate(): Promise<IIntegrationModel> {
    return new Promise(resolve => {
      const template: any = {
        id: '00000000000000000000000000000000',
        fromniToken: null,
        clubId: this.clubId,
      };
      resolve(template);
    });
  }
}

